import React from 'react';
import NttSection from '../components/nttcourse/NttSection';
import JoinCourseForm from '../components/JoinCourseForm';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/NTT-Seminar.JPG";
import SeoContentSection from "../components/SeoContentSection";


const NttCourse = () => {
  return (
    <>
<UniqueBanner
  image={BannerImg}
  title="Nursery Teacher Training"
  subtitle="Empowering aspiring teachers with practical and theoretical early childhood education skills"
 />
 <NttSection />
 <SeoContentSection title="Nursery Teacher Training Course">
   <p>
     NIECCE's nursery teacher training course prepares aspiring educators for rewarding careers in preschools, nurseries, Montessori environments, and early learning centers. The NTT and Montessori integrated curriculum combines child development theory with practical classroom activities.
   </p>
   <p>
     Students learn storytelling, phonics, puppetry, rhymes, handwriting, Montessori practicals, classroom management, and other skills that support joyful learning. Online and regular options, expert faculty, certification, and placement assistance help learners move confidently into teaching.
   </p>
 </SeoContentSection>
 <JoinCourseForm />
    </>
  );
};

export default NttCourse;
